module.exports = __webpack_public_path__ + "static/media/Pirate_Cove-1.8f1cb29b.webp";